export default __webpack_public_path__ + "static/media/VolvoNovum-Light.e02f9210.woff";